import { render, staticRenderFns } from "./SharePanel.vue?vue&type=template&id=55f4d1e3&"
import script from "./SharePanel.vue?vue&type=script&lang=js&"
export * from "./SharePanel.vue?vue&type=script&lang=js&"
import style0 from "./SharePanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports